import React, { useState } from "react";
import { CloudDownloadOutlined } from '@ant-design/icons';
import {
    Button,
    Row,
    Typography,
    Col,
    Card,
    Select,
    Form,
} from "antd";



const { Text, Title } = Typography;
const Option = Select;

export default function DownloadForm({ onCancel, disabled, setDisabled,title }) {
    const [formData, setFormData] = useState(null);
    const [currentTemplate, setCurrentTemplate] = useState({ hookTemp: "" });


    const onFinishForm = (values) => {
        console.log(values);
        setFormData(values);
    }


    const [form] = Form.useForm();

    const handleValuesChange = (changedValues, allValues) => {
        setCurrentTemplate(changedValues);
        console.log(currentTemplate);
    }



    return (
        <Form layout="vertical" onFinish={onFinishForm} form={form} initialValues={formData} onValuesChange={handleValuesChange}
        >
            <Card
                style={{
                    marginBottom: "2%",
                    boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                }}
                title={`${title} Template`}
            >
                <Row
                    gutter={{
                        xs: 8,
                        sm: 16,
                        md: 24,
                        lg: 32,
                    }} style={{ justifyContent: "space-between" }}>
                    <Col style={{ paddingTop: 10 }}>
                        <Form.Item
                            label={<Text strong>Branch</Text>}
                            name="branch"
                            rules={[{
                                required: true,
                                message: "Required Field"
                            }]}
                        >
                            <Select
                                disabled={disabled}
                                showSearch
                                placeholder='Select Branch' style={{ width: "30vh" }}
                            >
                                <Option value={"headOffice"}>HEAD OFFICE</Option>
                                <Option value={"testOffice"}>TEST_OFFICE</Option>
                                <Option value={"branchOffice"}>Branch_Office_!</Option>
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col style={{ paddingTop: 10 }}>
                        <Form.Item
                            label={<Text strong>Staff</Text>}
                            name="staff"
                        >
                            <Select
                                showSearch
                                placeholder='Select Option' style={{ width: "30vh" }}
                            >
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col style={{ paddingTop: 10 }}>
                        <Form.Item
                            label={<Text strong></Text>}
                            name="payload"

                        >
                            <Button
                                type="primary"
                                icon={<CloudDownloadOutlined />}
                                style={{ backgroundColor: "#92428B", color: "white" }}
                            >
                                Download
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Card>
        </Form >
    );
}
